import Spinners from 'components/Common/Spinner';
import TableContainer from 'components/Common/TableContainer';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Col, Input, Label, Row } from 'reactstrap';
import { getAllStaff, getGatePassReport } from 'store/actions';
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";

const GatePassReport = () => {
    const dispatch = useDispatch();


    const [reportInputs, setReportInputs] = useState({
        staff_id: null,
        status: null,
        actual_checkout_from: null,
        actual_checkout_to: null,

    })

    const { gatePassReport, allStaffList, loading, message, error, isCreated } = useSelector(state => state.GatePassReducer);

    const columns = useMemo(
        () => [
            {
                Header: () => <div style={{ color: "#111" }}>#</div>,
                accessor: "id",
                filterable: true,
                Cell: ({ row, rows }) => {
                    const rowIndex = rows.indexOf(row) + 1
                    return rowIndex
                },
            },
            {
                Header: () => <div style={{ color: "#111" }}>Request</div>,
                accessor: "created_date",
                filterable: true,
                Cell: ({ value }) => moment(value).format("DD/MM/YYYY HH:mm:ss") || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Staff</div>,
                accessor: "staff_name",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Reason</div>,
                accessor: "reason",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>CheckOut</div>,
                accessor: "requested_checkout",
                filterable: true,
                Cell: ({ value }) => moment(value).format("DD/MM/YYYY HH:mm:ss") || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Checkout By</div>,
                accessor: "checkout_by_name",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>CheckIn</div>,
                accessor: "requested_checkin",
                filterable: true,
                Cell: ({ value }) => moment(value).format("DD/MM/YYYY HH:mm:ss") || "",
            },
            {
                Header: () => <div style={{ color: "#111" }}>Checkin By</div>,
                accessor: "checkin_by_name",
                filterable: true,
                Cell: ({ value }) => value || "",
            },
            // {
            //     Header: () => <div style={{ color: "#111" }}>hours</div>,
            //     accessor: "xyz",
            //     filterable: true,
            //     Cell: ({ value, row }) => {
            //         const checkin = row.original.requested_checkin;
            //         const checkout = row.original.requested_checkout; // Replace with your actual accessor

            //         return calculateHours(checkout, checkin) || "";
            //     },
            // },
            {
                Header: () => <div style={{ color: "#111" }}>Status</div>,
                accessor: "status",
                filterable: true,
                Cell: ({ value, row }) => value,
            },


        ],
        [gatePassReport]
    );


    useEffect(() => {
        dispatch(getGatePassReport(reportInputs))
    }, [reportInputs])

    useEffect(() => {
        dispatch(getAllStaff())
    }, [dispatch])
    return (
        <div className='page-content container'>


            <div>
                <h4>Gate Pass Report</h4>
            </div>

            <div>
                <Row className='my-4'>
                    <Col md={6} className='mb-2'>
                        <Label>Select Staff</Label>
                        <Input
                            type='select'
                            onChange={(e) => setReportInputs({
                                ...reportInputs,
                                staff_id: e.target.value
                            })}>
                            <option value={''}>SELECT STAFF</option>
                            {allStaffList.map((staff, index) => (<option key={index} value={staff.staff_id}>{staff.staff_name}</option>))}
                        </Input>
                    </Col>

                    <Col md={6} className='mb-2'>
                        <Label>Select Status</Label>
                        <Input
                            type='select'
                            onChange={(e) => setReportInputs({
                                ...reportInputs,
                                status: e.target.value
                            })}>
                            <option value={''}>Select Status</option>
                            <option value={"Checked-In / Completed"}>Checked-In / Completed</option>
                            <option value={"Approved"}>Approved</option>
                            <option value={"Pending"}>Pending</option>
                            <option value={"Checked-Out"}>Checked-Out</option>
                        </Input>
                    </Col>


                    <Col md={6} className='mb-2'>
                        <Label>Select Checkout Date FROM</Label>
                        <FlatPickr
                            className="form-control"
                            name="planned_date_from"
                            placeholder="Select Planned Date From"
                            options={{
                                dateFormat: "d/m/Y",
                            }}
                           value={
                                 reportInputs.actual_checkout_from
                                     ? moment(reportInputs.actual_checkout_from).format("DD-MM-YYYY")
                                     : null
                             }


                            onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                setReportInputs({
                                    ...reportInputs,
                                    actual_checkout_from: selectedDates[0]
                                })
                            }}
                        />
                    </Col>



                    <Col md={6} className='mb-2'>
                        <Label>Select Checkout Date TO</Label>
                        <FlatPickr
                            className="form-control"
                            name="planned_date_from"
                            placeholder="Select Planned Date From"
                            options={{
                                dateFormat: "d/m/Y",
                            }}
                             value={
                                 reportInputs.actual_checkout_to
                                     ? moment(reportInputs.actual_checkout_to).format("DD-MM-YYYY")
                                     : null
                             }


                            onChange={(selectedDates) => {
                                console.log("Selected Date:", selectedDates[0]);
                                setReportInputs({
                                    ...reportInputs,
                                    actual_checkout_to: selectedDates[0]
                                })
                            }}
                        />
                    </Col>

                </Row>
            </div>
            {loading ? (
                <Spinners />
            ) : (
                <TableContainer
                    columns={columns}
                    data={gatePassReport}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={100}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                />
            )}
        </div>
    )
}

export default GatePassReport